// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"loader_spinnerContainer__5FHqZ","loadingSpinner":"loader_loadingSpinner__pGfH4","spinner":"loader_spinner__iZot7"};